import script from "./InfoBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoBlock.vue?vue&type=script&setup=true&lang=ts"

import "./InfoBlock.vue?vue&type=style&index=0&id=181d29c8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181d29c8"]])

export default __exports__